import FJConfig from '../config/FJConfig';
import FJUtil from '../util/FJUtil';
const BASE_URL = FJConfig.requestPath;
const LOCAL_USER_ID = '362';

const _isTeamSpace = () => {
    // TODO:团队 移动端暂时使用个人积分
    return FJUtil.isTeamSpace() && !FJUtil.isMobile();
};
const _fetch = async (api, formData, method = 'POST') => {
    const url = BASE_URL + api;
    if (FJUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);
    // else {
    //     const uid = FJUtil.getUserId();
    //     uid && formData.append('uid', uid);
    // }
    const response = await fetch(url, {
        method,
        body: formData,
    });
    const { data, code } = await response.json();
    if (code === 200) {
        return data;
    }
    return null;
};

export default {
    /**
     * 图生图
     * @param {*} data
     * @returns
     */
    imgToImg: async options => {
        const { prompt, image, negativePrompt, conditionScale, seed, numOutputs, style } = options;
        const url = BASE_URL + '/ai/img-to-img';
        const formData = new FormData();
        formData.append('prompt', prompt);
        formData.append('image', image);
        formData.append('style', style);
        formData.append('num_outputs', numOutputs);

        negativePrompt && formData.append('negative_prompt', negativePrompt);
        conditionScale && formData.append('condition_scale', conditionScale);
        seed && formData.append('seed', seed);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },
    imageProcessing: async options => {
        const {
            image,
            colorize,
            enhance,
            repair,
            factor,
            scratch_repair_mask,
            scratch_repair,
            original_image,
            generate_mask,
        } = options;
        // const { image, colorize, enhance, repair, factor, modelType } = options;
        const url = BASE_URL + '/ai/image-processing';
        const formData = new FormData();
        formData.append('image', image);
        formData.append('colorize', colorize);
        formData.append('enhance', enhance);
        formData.append('repair', repair);
        enhance && formData.append('factor', factor);
        scratch_repair_mask && formData.append('scratch_repair_mask', scratch_repair_mask);
        scratch_repair && formData.append('scratch_repair', scratch_repair);
        original_image && formData.append('original_image', original_image);
        generate_mask && formData.append('generate_mask', generate_mask);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        // enhance && formData.append('model_type', modelType);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 生成 自动划痕检测 mask 图
     * @param {*} options
     * @returns
     */
    generateScratchRepairMask: async options => {
        const { imageUrl } = options;
        const url = BASE_URL + '/ai/generate-scratch-repair-mask';
        const formData = new FormData();
        formData.append('image', imageUrl);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();

        if (code === 200) {
            return data.mask;
        }
        return null;
    },

    imageEnhancer: async options => {
        const { image, factor } = options;
        const url = BASE_URL + '/ai/image-enhancer-task';
        const formData = new FormData();
        formData.append('image', image);
        formData.append('factor', factor);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },
    clothesChanger: async options => {
        const { image, garment } = options;
        const url = BASE_URL + '/ai/create-clothes-changer-task';
        const formData = new FormData();
        formData.append('image', image);
        formData.append('garment', garment);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },
    /**
     * 获取任务状态
     * @param {} eventId
     * @returns
     */
    getTaskState: async eventId => {
        const api = '/rp/get-state';
        const formData = new FormData();
        formData.append('event_id', eventId);
        try {
            return await _fetch(api, formData);
        } catch (error) {
            return;
        }
    },
    /**
     * 获取任务状态
     * @param {} eventId
     * @returns
     */
    cancelTask: async eventId => {
        const api = '/rp/cancel';
        const formData = new FormData();
        formData.append('event_id', eventId);
        return await _fetch(api, formData);
    },
    /**
     * 获取免费使用次数
     * @returns
     */
    getUseFreeLimit: async () => {
        const api = '/ai/get-use-free-limit';
        const formData = new FormData();
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        return await _fetch(api, formData);
    },
    /**
     * 获取图片列表
     * @param {*} eventType 3：图生图 4:图像处理
     * @returns
     */
    getTaskList: async (eventType = '3') => {
        const api = '/ai/task-list';
        const formData = new FormData();
        formData.append('event_type', eventType);
        return await _fetch(api, formData);
        // 增强数据
        // return [
        //     {
        //         id: 10800,
        //         user_id: 151000,
        //         event_id: 'df9bc8ebdb24a57f27b0653995f2aa9b',
        //         original: '343955dd9e1b3c9efa3ad2e19d0e3c749f5569c05460f171e28326c02e12cbdc.png',
        //         result: '95ab2c2c0aef490098f61a9ca0e570c6.png',
        //         job_type: 5,
        //         has_watermark: 0,
        //         created_at: '2024-12-19 08:42:57',
        //         info: '{"width":3328,"height":4608}',
        //         style: null,
        //         share_key: '10800d299a92004734135de74355770b7c785',
        //         request_params: {
        //             super_resolution_factor: 4,
        //             original_image: null,
        //         },
        //     },
        //     {
        //         id: 10799,
        //         user_id: 151000,
        //         event_id: 'd84785d3dfb0a1cad37c17d2052fc11e',
        //         original: '343955dd9e1b3c9efa3ad2e19d0e3c749f5569c05460f171e28326c02e12cbdc.png',
        //         result: '773bf023ed8e35a63e9e2fbcbf2a759b.png',
        //         job_type: 5,
        //         has_watermark: 0,
        //         created_at: '2024-12-19 08:38:04',
        //         info: '{"width":1664,"height":2304}',
        //         style: null,
        //         share_key: '10799c36b81d5293acd2e3d41f1bdc1d0aefb',
        //         request_params: {
        //             super_resolution_factor: 2,
        //             original_image: null,
        //         },
        //     },
        //     {
        //         id: 10574,
        //         user_id: 151000,
        //         event_id: 'd7ded5d079e899aa777aafe9cd0d8e1c',
        //         original: '343955dd9e1b3c9efa3ad2e19d0e3c749f5569c05460f171e28326c02e12cbdc.png',
        //         result: '3f934ef809b7a2cb46dc1ae85441702e.png',
        //         job_type: 5,
        //         has_watermark: 0,
        //         created_at: '2024-12-18 06:54:19',
        //         info: '{"width":1664,"height":2304}',
        //         style: null,
        //         share_key: '10574f1cf2a082126bf02de0b307778ce73a7',
        //         request_params: {
        //             super_resolution_factor: 2,
        //             original_image: null,
        //         },
        //     },
        //     {
        //         id: 10527,
        //         user_id: 151000,
        //         event_id: 'b3ae1d4d495577ca6e54139fecfb9f89',
        //         original: 'b738c501dd10f4f4c20ead2e48c958c2c62ccbda0afcb8919ecc7b971b787dc1.png',
        //         result: 'ff5c68c1f1b4a095c7b10189bca88a06.png',
        //         job_type: 5,
        //         has_watermark: 0,
        //         created_at: '2024-12-18 02:23:42',
        //         info: '{"width":6044,"height":2048}',
        //         style: null,
        //         share_key: '10527a79c7a2d44b2ca012e938b0cf16bc04f',
        //         request_params: {
        //             super_resolution_factor: 4,
        //             original_image: null,
        //         },
        //     },
        //     {
        //         id: 10526,
        //         user_id: 151000,
        //         event_id: 'aba6867353732d38b487a3866e1a0915',
        //         original: 'b738c501dd10f4f4c20ead2e48c958c2c62ccbda0afcb8919ecc7b971b787dc1.png',
        //         result: '7b578700e836e8cf80975fe898cbf493.png',
        //         job_type: 5,
        //         has_watermark: 0,
        //         created_at: '2024-12-18 02:23:37',
        //         info: '{"width":6044,"height":2048}',
        //         style: null,
        //         share_key: '105268fa2a95ee83cd1633cfd64f78e856bd3',
        //         request_params: {
        //             super_resolution_factor: 4,
        //             original_image: null,
        //         },
        //     },
        // ];
    },
    deleteTaskList: async ids => {
        const url = BASE_URL + '/rp/delete';
        const formData = new FormData();
        formData.append('ids', ids);
        if (FJUtil.isLocalhost()) formData.append('uid', LOCAL_USER_ID);

        const response = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await response.json();
        return { data, code };
    },
    /**
     * @description 返回积分额度
     * @returns {Promise<{[p: string]: *}>}
     */
    async getCreditsInfo() {
        let url = FJConfig.requestPath + '/user/get-credit-info';
        if (_isTeamSpace()) url += `?tid=${FJUtil.getCurrentSpaceId()}`;

        const res = await fetch(url, { method: 'GET' });
        const { code, data } = await res.json();
        if (code !== 200) {
            throw new Error(code.toString());
        }
        return data;
    },
    async checkIsLogin() {
        const url = FJConfig.requestPath + '/user/checkState';
        const res = await fetch(url, {
            method: 'GET',
        });
        const { data, code } = await res.json();
        return data?.result && code == 200;
    },
    async getSpaceData() {
        const url = FJConfig.requestPath + '/user/get-space-data';
        const res = await fetch(url, {
            method: 'GET',
        });
        const { code, data } = await res.json();
        if (code !== 200) {
            throw new Error(code.toString());
        }
        return data;
    },

    async textToImage(param) {
        const url = BASE_URL + '/ai/new-text-to-image';
        const formData = new FormData();
        formData.append('prompt', param.prompt);
        formData.append('model_type', param.model_type);
        formData.append('aspect_ratio', param.ratio);
        formData.append('num_outputs', param.generateNumber);
        formData.append('style', param.style);
        formData.append('prompt_val', param.prompt_val);
        formData.append('input_prompt', param.input_prompt);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 翻译value
     * @param {JSON} value
     * @param toLanguage
     * @returns {Promise<any>}
     */
    async translateValueToLanguage(value, toLanguage = 'en') {
        // 使用我们的接口
        const formData = new FormData();
        formData.append('data', JSON.stringify(value));
        formData.append('to_language', toLanguage);

        const response = await fetch(BASE_URL + '/ai/translate-text', {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await response.json();
        if (code === 200) {
            const list = JSON.parse(data);
            return list;
        }
    },

    /**
     * @description 生成图片描述
     * @param {String} fileUrl
     * @param {String} currentLang
     * @returns {Promise<any>}
     */
    async generateImageByPrompt(fileUrl, currentLang = 'en') {
        const url = BASE_URL + '/ai/generate-image-desc';
        const formData = new FormData();
        formData.append('image', fileUrl);
        formData.append('current_lang', currentLang);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc AI提示词优化
     * @returns
     */
    async aiOptimizing(prompt) {
        const url = BASE_URL + '/ai/optimization-description';

        const urlWithParams = `${url}?prompt=${prompt}`;

        const res = await fetch(urlWithParams, {
            method: 'GET',
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc AI图片扩展
     * @returns
     */
    async imageExtender(imageUrl, left, right, top, bottom) {
        const url = BASE_URL + '/ai/create-image-extender-task';
        const formData = new FormData();
        formData.append('image', imageUrl);
        formData.append('left', left);
        formData.append('right', right);
        formData.append('top', top);
        formData.append('bottom', bottom);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc AI换脸
     * @returns
     */
    async faceSwap(originImageUrl, targetImageUrl) {
        const url = BASE_URL + '/ai/create-face-swap-task';
        const formData = new FormData();
        formData.append('face_swap_target', originImageUrl);
        formData.append('image', targetImageUrl);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @description 生成深度图
     * @param {String} fileUrl
     * @param {String} currentLang
     * @returns {Promise<any>}
     */
    async generateDepthMap(fileUrl) {
        const url = BASE_URL + '/ai/depth-map';
        const formData = new FormData();
        formData.append('image', fileUrl);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
    async updateDepthMapInfo(evenId, info) {
        const url = BASE_URL + '/ai/update-depth-map-info';
        const formData = new FormData();
        formData.append('event_id', evenId);
        formData.append('info', info);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const { data, code } = await res.json();
        return { data, code };
    },
    async addUseValue(type, number) {
        const url = BASE_URL + '/ai/add-use-value';
        const formData = new FormData();
        formData.append('type', type);
        formData.append('number', number);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        try {
            const res = await fetch(url, {
                method: 'POST',
                body: formData,
            });
            const { code } = await res.json();
            if (code === 200) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    },

    /**
     * @desc 获取AI mask
     * @returns
     */
    async getAiMask(imageUrl) {
        const url = BASE_URL + '/ai/analyze-image-generate-mask';

        const formData = new FormData();
        formData.append('image', imageUrl);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();

        if (code === 200) {
            return data && data.json;
        }
        return null;
    },

    /**
     * @desc 物体擦除
     * @returns
     */
    async objectEraserTask(options) {
        const url = BASE_URL + '/ai/object-erasure-task';

        const { image, mask, original_image, prompt } = options;
        const formData = new FormData();
        formData.append('image', image);
        formData.append('mask', mask);
        original_image && formData.append('original_image', original_image);
        prompt && formData.append('prompt', prompt);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 手动去创建背景擦除历史
     * @returns
     */
    async createRemoveBackgroundHistory(options) {
        const url = BASE_URL + '/ai/create-remove-background-history';
        const formData = new FormData();
        formData.append('filename', options.filename);
        formData.append('original', options.original);
        formData.append('info', JSON.stringify(options.info));
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 自动去背景
     * @returns
     */
    async autoBackgroundRemove(options) {
        const url = BASE_URL + '/ai/auto-background-remove';
        const formData = new FormData();
        formData.append('image', options.image);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        try {
            const res = await fetch(url, {
                method: 'POST',
                body: formData,
            });

            const { data, code } = await res.json();
            return { data, code };
        } catch (error) {
            return { data: null, code: 500 };
        }
    },

    /**
     * @desc AI生成视频
     * @returns
     */
    async videoGeneration(options) {
        const url = BASE_URL + '/ai/create-video-generation-task';
        const { imageUrl, generationType, modelType, prompt, duration, ratio, waterfallRatio, source } = options;
        const formData = new FormData();
        formData.append('generation_type', generationType);
        formData.append('model_type', modelType);
        formData.append('image_url', imageUrl);
        prompt && formData.append('prompt', prompt);
        formData.append('duration', duration);
        formData.append('aspect_ratio', ratio);
        formData.append('waterfall_ratio', waterfallRatio);
        formData.append('source', source);
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    /**
     * @desc 视频去背景添加预测点
     * @returns
     */
    async videoRemoveBackgroundAddPoints(currentTime, objectId, points, base64String) {
        try {
            const normalizedPoints = points.map(p => [p[0], p[1]]);
            const labels = points.map(() => 1);

            const res = await fetch(BASE_URL + '/ai/add-points', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    session_id: '0',
                    frame_index: 0,
                    object_id: objectId,
                    labels,
                    points: normalizedPoints,
                    clear_old_points: true,
                    start_time: currentTime,
                    image_base64: base64String,
                }),
            });

            const data = await res.json();
            return data;
        } catch (err) {
            return null;
        }
    },

    /**
     * @desc 自动视频去背景
     * @returns
     */
    async autoVideoRemoveBackground(options) {
        let fetchUrl = BASE_URL + '/ai/auto-rm-video-bg';

        if (_isTeamSpace()) {
            fetchUrl += `?tid=${FJUtil.getCurrentSpaceId()}`;
        }

        const res = await fetch(fetchUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(options),
        });

        const data = await res.json();

        if (data.code === 200) {
            return data.data;
        }
        return null;
    },

    /**
     * @desc 视频去背景跟踪
     * @returns
     */
    async videoRemoveBackgroundTrack(options) {
        let fetchUrl = BASE_URL + '/ai/manually-rm-video-bg';

        if (_isTeamSpace()) {
            fetchUrl += `?tid=${FJUtil.getCurrentSpaceId()}`;
        }

        const res = await fetch(fetchUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(options),
        });

        const data = await res.json();
        return data;
    },
    async audioGeneration(options) {
        const url = BASE_URL + '/ai/generate-music-task';
        const { audioUrl, voiceUrl, incidentalUrl, lyrics, info } = options;
        const formData = new FormData();
        audioUrl && formData.append('song_file', audioUrl);
        voiceUrl && formData.append('voice_file', voiceUrl);
        incidentalUrl && formData.append('instrumental_file', incidentalUrl);
        lyrics && formData.append('lyrics', lyrics);
        formData.append('info', JSON.stringify(info));
        if (_isTeamSpace()) {
            formData.append('tid', FJUtil.getCurrentSpaceId());
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    async generateLyric(options) {
        const url = BASE_URL + '/ai/generate-lyrics';
        const { content, currentLang } = options;
        const formData = new FormData();
        formData.append('content', content);
        currentLang && formData.append('current_lang', currentLang);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },

    async updateEventInfo(options) {
        const url = BASE_URL + '/ai/update-event-info';
        const { eventId, info } = options;
        const formData = new FormData();
        formData.append('event_id', eventId);
        formData.append('info', JSON.stringify(info));

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
    async regenerateCoverImage(options) {
        const url = BASE_URL + '/ai/regenerate-cover-image';
        const { videoUrl, eventId } = options;
        const formData = new FormData();
        formData.append('event_id', eventId);
        formData.append('url', videoUrl);

        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const { data, code } = await res.json();
        return { data, code };
    },
};
